import { Component, computed, input } from '@angular/core';

import {
  formatCellValue,
  processStringValue
} from '@shared/components/table/table-cell/utils';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';
import { CellWithOverlayActions } from '../../table-cell.component';

@Component({
  selector: 'app-string-cell',
  standalone: true,
  templateUrl: './string-cell.component.html'
})
export class StringCellComponent implements CellWithOverlayActions {
  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'string');

  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<string>(() => processStringValue(this.value()));
}
